module.exports = __webpack_public_path__ + "img/schmucklicloud_label_black.33f03f6f.png";